import { Button } from '@chakra-ui/react'
import React from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import useFile from '@/features/files/useFile'
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'
import { useDispatch } from 'react-redux'

const ViewFileButton = ({ colorScheme = 'blue', fileName, fileId, isHide = false }) => {
  const { id } = useParams()

  const dispatch = useDispatch()

  const { useDownloadFile } = useFile()
  const downloadFile = useDownloadFile()

  const handleViewFile = async () => {
    try {
      dispatch(showLoadingOverlay())

      const response = await downloadFile.mutateAsync(fileId)
      const contentDisposition = response.headers['content-disposition']
      let fileName = 'e-approval-file'

      if (contentDisposition && contentDisposition.includes('filename=')) {
        fileName = contentDisposition.split('filename=')[1].replace(/"/g, '')
      }

      const fileType = response.headers['content-type']
      if (fileType === 'application/pdf') {
        const blob = new Blob([response.data], {
          type: response.headers['content-type'],
        })

        const fileUrl = URL.createObjectURL(blob)

        window.open(fileUrl)
      } else {
        toast.error("This file type can't be preview, please download it instead.")
        return
      }
    } catch (err) {
      toast.error(`${err}`)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }

  return (
    <>
      {!isHide && (
        <Button
          colorScheme={colorScheme}
          onClick={(e) => {
            e.stopPropagation()

            handleViewFile()
          }}
        >
          View
        </Button>
      )}
    </>
  )
}

export default ViewFileButton
